import Immutable from 'immutable';

export interface RawNewSubmittal {
  id: string;
  projectid: string;
  specsectionnumber: string;
  specsectionname: string;
  category: string | null;
  description: string;
  status: string;
  ballincourt: string;
  responsiblecompany: string;
  duefromsub: number;
  duefromreviewer: number;
  leadtime: string;
  requiredonsite: number;
}

export interface NewSubmittalData {
  id: string;
  projectid: string;
  specsectionnumber: string;
  specsectionname: string;
  category: string | null;
  description: string;
  status: string;
  ballincourt: string;
  responsiblecompany: string;
  duefromsub: number;
  duefromreviewer: number;
  leadtime: string;
  requiredonsite: number;
}

const defaultValues: NewSubmittalData = {
  id: '',
  projectid: '',
  specsectionnumber: '',
  specsectionname: '',
  category: null,
  description: '',
  status: 'SUB_NOT_YET_REQUESTED',
  ballincourt: '',
  responsiblecompany: '',
  duefromsub: 0,
  duefromreviewer: 0,
  leadtime: '',
  requiredonsite: 0,
};

export const NewSubmittalFactory = Immutable.Record(
  defaultValues,
  'NewSubmittal'
);

export class NewSubmittal extends NewSubmittalFactory {
  serialize(): RawNewSubmittal {
    return this.toJS();
  }

  static deserialize(rawNewSubmittal: RawNewSubmittal): NewSubmittal {
    return new NewSubmittal({
      ...rawNewSubmittal,
    });
  }
}
